import { Injectable } from '@angular/core';
import { IMediaLibraryHandlerStrategy } from '../../../models/util/mediaLibraryHandlerStrategy';
import { MediaLibraryFile } from '../../../enums/mediaLibraryFileType.enum';
import { Video } from '../../../models/video';
import { isNullOrUndefined } from '@pineapplelab/util';
import { StorageService } from '../../storage/storage.service';
import { environment } from '../../../../environments/environment';
import { Project } from '../../../models/project';
import { FileUtils } from '../../../utils/fileUtils';

@Injectable({
	providedIn: 'root'
})
export class MediaLibraryImageService implements IMediaLibraryHandlerStrategy {

	type: MediaLibraryFile = MediaLibraryFile.IMAGE;

	constructor(
		private storageService: StorageService
	) {}

	async preprocess(file: File): Promise<Video> {
		const video = new Video();
		video.fileName = file?.name;
		video.fileSize = FileUtils.getMB(file).toFixed(2);
		video.__file = file;
		const thumbnailImage = URL.createObjectURL(file);
		video.__fileThumbnail = file;
		video.thumbnail = thumbnailImage;
		video.fileType = this.type;
		return video;
	}

	async getThumbnail(media: Video): Promise<string> {
		if (isNullOrUndefined(media?.__file) || !(media.__file instanceof File)) {
			return null;
		}
		return this.storageService.saveOrRemoveImagesIfNecessary(media.__file, `${Project.PATH}/${environment.projectId}/${Video.PATH}/${media.id}`);
	}

}
